import axios from "axios";
import * as ROUTES from "../../constants/route";
import Helpers from "../Helpers";
import { buildRedemptionRequest } from "../Redemption/redemptionState";
import { materializeUploadFile } from "../../utils/uploadFiles";

export default class Functions {
  constructor() {
    this.helpers = new Helpers();
  }

  doUploadDepositSlip = async (data) => {
    const token = this.helpers.getCookie("token");
    const picture = await materializeUploadFile(data.picture);
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("req", JSON.stringify({ fundId: data.transactionId }));
      formData.append("picture", picture);
      axios
        .post(
          `${ROUTES.FUNCTION_BASE_URL}investments-investments/uploadDepositSlip`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };

  doRedeemInvestment = (data) => {
    const settlementDetails = buildRedemptionRequest(data);
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${ROUTES.FUNCTION_BASE_URL}v2/investments/redeem`,
          JSON.stringify(settlementDetails),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status === 409 &&
            err.response.data &&
            err.response.data.code === "full-redemption-confirmation-required"
          ) {
            reject(err);
            return;
          }
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };

  getRedemptionQuote = (investmentUid) => {
    const token = this.helpers.getCookie("token");
    return axios.get(
      `${ROUTES.FUNCTION_BASE_URL}v2/investments/redemption-quote/${investmentUid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };
}
